var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashCanCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25730",
    "data-name": "Group 25730",
    transform: "translate(-1256 -1119)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1564",
    "data-name": "Ellipse 1564",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(1256 1119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(1214 1124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7343",
    "data-name": "Path 7343",
    d: "M54.3,1.072H52.826V.8a.8.8,0,0,0-.8-.8H50.949a.8.8,0,0,0-.8.8v.268H48.67a.67.67,0,0,0-.67.67v.536a.268.268,0,0,0,.268.268H54.7a.268.268,0,0,0,.268-.268V1.743A.67.67,0,0,0,54.3,1.072ZM50.681.8a.268.268,0,0,1,.268-.268h1.072A.268.268,0,0,1,52.29.8v.268H50.681Z",
    fill: "#172b37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7344",
    "data-name": "Path 7344",
    d: "M73.448,184a.084.084,0,0,0-.084.088l.221,4.643a.8.8,0,0,0,.8.766h4.072a.8.8,0,0,0,.8-.766l.221-4.643A.084.084,0,0,0,79.4,184Zm4.049.67a.268.268,0,0,1,.536,0v3.486a.268.268,0,1,1-.536,0Zm-1.341,0a.268.268,0,0,1,.536,0v3.486a.268.268,0,1,1-.536,0Zm-1.341,0a.268.268,0,0,1,.536,0v3.486a.268.268,0,1,1-.536,0Z",
    transform: "translate(-24.939 -180.917)",
    fill: "#172b37"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanCircle);
export default __webpack_public_path__ + "static/media/trash-can-circle.70ac584b2464a2eb85f93cc7813af778.svg";
export { ForwardRef as ReactComponent };